module.exports = __webpack_public_path__ + "fonts/NotoSans-Light.55e1764a.ttf";